export default {
  title: 'Applicant Status Change Notification Management',
  menu: 'Applicant Status Change Notification Management',
  label: {
    status: 'Applicant Status',
    emailTemplateToEmployeeCandidateName: 'To Candidate (Employee)',
    emailTemplateToCandidateName: 'To Candidate (Non-Employee)',
    hasConfig: {
      has: 'Configured',
      not: 'Not Configured'
    },
    emailTemplateToReferrerName: 'To Employee Referrer'
  },
  placeholder: {
    emailTemplateTo: 'Please select'
  },
  btn: {
    deleteConfig: 'Delete',
    saveConfig: 'Save',
    addConfig: 'Add'
  },
  message: {
    deleteSuccess: 'Delete Success',
    cannotSaveEmpty: 'Please configure at least one locking rule',
    checkConfigList: 'Error in the configuration table, please check'
  }
}
